module.exports = __webpack_public_path__ + "static/media/0017.c848d4c1.jpg";